<template>
  <div>
    <div>
      <b>{{client.title}}</b>
      <h3>API BASE URL</h3>
      <a :href="client.url">{{client.url}}</a>
      <h3>API KEY</h3>
      <md-field>
        <label>API KEY</label>
        <md-input :value="client.apiKey" type="password" readonly></md-input>
      </md-field>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    client: {
      apiKey: String,
      url: String,
      title: String,
    },
  },
};
</script>
